import common from './common.js';
import transition from './transition.js';

import header from './header.js';
import headerCarousel from './modules/header_carousel.js?v=1.0.1';
import stripOfLogos from './modules/strip_of_logos.js';
import imgContentGrid from './modules/image_content_grid.js';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

import '../scss/style.scss';

const app = {
  init() {
    transition.init();
    common.init();
    header.init();
    headerCarousel.init();
    stripOfLogos.init();
    imgContentGrid.init();
  }
};

window.onload = function() {
  // conversationPopup();
}

// Converstaion pop-up
function conversationPopup() {

  console.log('popup init');

  document.querySelectorAll('.cta').forEach(element => {
    element.addEventListener('click', (e) => {
      console.log('opening popup');
      e.preventDefault();
      document.querySelector('#gs-popup-cont').classList.add('active');
    });
  });

  document.querySelectorAll('.gs-close-popup').forEach(element => {
    element.addEventListener('click', (e) => {
      document.querySelector('#gs-popup-cont').classList.remove('active');
    });
  });
}

app.init();